/** A caller's startup timeout does NOT cancel Expo's native operation. Keep
 * ownership until the native promise settles, across all app entry points. */
export function createOtaCoordinator<Check, Download>(api: {
  checkForUpdateAsync: () => Promise<Check>
  fetchUpdateAsync: () => Promise<Download>
}) {
  let tail: Promise<unknown> = Promise.resolve()
  let checking: Promise<Check> | null = null
  let downloading: Promise<Download> | null = null

  function serialize<T>(operation: () => Promise<T>): Promise<T> {
    const result = tail.then(operation)
    // The next operation must still run after a failure. Callers get the
    // original rejecting promise; errors are not converted into success.
    tail = result.then(
      () => undefined,
      () => undefined,
    )
    return result
  }

  return {
    check(): Promise<Check> {
      checking ??= serialize(() => api.checkForUpdateAsync()).finally(() => {
        checking = null
      })
      return checking
    },
    fetch(): Promise<Download> {
      downloading ??= serialize(() => api.fetchUpdateAsync()).finally(() => {
        downloading = null
      })
      return downloading
    },
  }
}
